import { GridColumnVisibilityModel, GridDensity } from "@mui/x-data-grid"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { useAppSelector } from "../../app/hooks"

interface CommonState {
  density: GridDensity
  pagination: {
    page: number
    pageSize: number
  }
  columnVisisbilityModel: object
  sortModel: import("@mui/x-data-grid").GridSortModel
}

const initialState: CommonState = {
  density: "compact",
  pagination: {
    page: 0,
    pageSize: 15,
  },
  columnVisisbilityModel: {
    ruleId: true,
    ruleName: true,
    description: true,
    active: true,
    archive: true,
    adjustAmount: true,
    ruleType: true,
    adjustPriceType: true,
    adjustColumn: true,
    rounding: true,
    duration: true,
    startDate: true,
    endDate: true,
    actions: true,
  } as GridColumnVisibilityModel,
  sortModel: [],
}

const gridSlice = createSlice({
  name: "grid",
  initialState: initialState,
  reducers: {
    setDensity: (state, action: PayloadAction<GridDensity>) => {
      state.density = action.payload
    },

    setGridPaginationModel: (state, action: PayloadAction<PaginationModel>) => {
      state.pagination.page = action.payload.page
      state.pagination.pageSize = action.payload.pageSize
    },

    setPricingRulesColumnVisibilityModel: (
      state,
      action: PayloadAction<GridColumnVisibilityModel>,
    ) => {
      state.columnVisisbilityModel = action.payload
    },

    setGridSortModel: (
      state,
      action: PayloadAction<import("@mui/x-data-grid").GridSortModel>,
    ) => {
      state.sortModel = action.payload
    },
  },
})

export const {
  setDensity,
  setGridPaginationModel,
  setPricingRulesColumnVisibilityModel,
  setGridSortModel,
} = gridSlice.actions

export default gridSlice.reducer

export const useDensity = () =>
  useAppSelector((state: any) => state.grid.density)

export const usePaginationModel = () =>
  useAppSelector((state) => state.grid.pagination)

export const usePricingRulesColumnVisibilityModel = () =>
  useAppSelector((state) => state.grid.columnVisisbilityModel)

export const useSortModel = () =>
  useAppSelector((state) => state.grid.sortModel)
